import PropTypes from 'prop-types';
import { ListboxMultiselect } from '@evertrue/et-components';

/**
 * Wrapper around ListboxMultiselect that always keeps the filter name visible.
 *
 * Display format:
 *   - No selection  → "Label"
 *   - 1 selected    → "Label | selectedValue"
 *   - N selected    → "Label | Selected (N)"
 *
 * Drop-in replacement: accepts all ListboxMultiselect props.
 * The `label` prop is used as the filter name prefix.
 */
const FilterMultiselect = ({ label, values = [], ...rest }) => {
  let displayLabel = label;
  if (values.length === 1) {
    displayLabel = `${label} | ${values[0].label}`;
  } else if (values.length > 1) {
    displayLabel = `${label} | Selected (${values.length})`;
  }

  return <ListboxMultiselect label={displayLabel} alwaysShowLabel={true} values={values} {...rest} />;
};

FilterMultiselect.propTypes = {
  label: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string })),
};

export default FilterMultiselect;
